'use strict';

var bssdragresize = angular.module("bss.dragresize", [])
  .directive("bssdraggable", [require("./BSSDraggable")])
  .directive("bssresizable", [require("./BSSResizable")])
;

module.exports = bssdragresize;

